import { useLocation } from 'react-router-dom'

export const useIsDiscoverPage = () => {
  const currentLocation = useLocation()
  return currentLocation.pathname === '/' ||
    currentLocation.pathname === '/discover'
    ? true
    : false
}
